import App from '@/views/constants/app';
import Helpers from '@/shared/helpers/functions';

import RoS from '@/views/constants/reports-of-sickness';

const Filters = {
  create () {
    return {
      search: '',
      fromDate: Helpers.Dates.addYears(new Date().toISOString().substr(0, 10), -3),
      untilDate: new Date().toISOString().substr(0, 10),
      minDate: Helpers.Dates.addYears(new Date().toISOString().substr(0, 10), -3),
      maxDate: new Date().toISOString().substr(0, 10),
      showClosed: true,
      showOpen: true,
      pagination: {
        sortBy: 'reportOfSickness.firstOfAbsence',
        descending: true,
        rowsPerPage: 25
      }
    };
  }
};

const state = {
  filters: Filters.create()
};

const getters = {
  reportsOfSicknessIndexFilters: state => state.filters
};

const actions = {
  [RoS.Actions.CHANGE_INDEX_FILTER] ({ commit }, data) {
    commit(RoS.Mutations.SET_INDEX_FILTER, data);
  }
};

const mutations = {
  [RoS.Mutations.SET_INDEX_FILTER] (state, payload) {
    state.filters[payload.filter] = payload.value;
  },
  [RoS.Mutations.CLEAR] (state) {
    state.filters = Filters.create();
  },
  [App.Mutations.CLEAR] (state) {
    state.filters = Filters.create();
  }
};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
